import { Grid } from "@mui/material";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

export function Bool({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <Grid item xs={6} alignItems="center" className={classes.boolWrapper}>
      <Grid alignItems="center" component="label" container spacing={1}>
        <Grid item>{message({ id: "false" })}</Grid>
        <Grid item>
          <Toggle data-test-id="condition-value" name={`${fieldName}.data`} />
        </Grid>
        <Grid item>{message({ id: "true" })}</Grid>
      </Grid>
    </Grid>
  );
}
